var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { PrivateRouteWrapper } from "./private-routes-wrapper";
import GoogleAnalyticsTrackingWrapper from "@/main/config/google-analytics/google-analytics-tracking-wrapper";
import HotjarTrackingWrapper from "@/main/config/hotjar-tracking/hotjar-tracking-wrapper";
export var PrivateRouteWithTrackingWrapper = function (_a) {
    var children = _a.children, authClient = _a.authClient, googleAnalytics = _a.googleAnalytics, hotjar = _a.hotjar, canTrackThisRoute = _a.canTrackThisRoute, props = __rest(_a, ["children", "authClient", "googleAnalytics", "hotjar", "canTrackThisRoute"]);
    return (React.createElement(PrivateRouteWrapper, __assign({ authClient: authClient }, props),
        React.createElement(GoogleAnalyticsTrackingWrapper, { initialized: canTrackThisRoute && (googleAnalytics === null || googleAnalytics === void 0 ? void 0 : googleAnalytics.initialized) },
            React.createElement(HotjarTrackingWrapper, { initialized: canTrackThisRoute && (hotjar === null || hotjar === void 0 ? void 0 : hotjar.initialized) }, children))));
};
